// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_35eoE","ico":"_2a0MH","title":"_2Cs2u","id":"_2UGhI"};